import DatePicker from 'vue2-datepicker';
import { ModelSelect, BasicSelect } from 'vue-search-select';
import commonHelper from '@/app/utility/common.helper.utility';
import tenantLease from '../../../leases/tenantLease';
import Currency from '../../../../../admin/currency';
import party from '../../../../../generalLedger/party';
import masterAgreement from '../../../leases/masterAgreement';
import requestLease from '../../../../../request/submittedRequest';
import templateLease from '../../../../../request/template';
import store from '../../../../../../../store';
import appStrings from '@/app/utility/string.utility';
export default {
  name: 'AdvanceSearch',
  components: {
    DatePicker,
    BasicSelect,
    ModelSelect,
    tenantLease,
    masterAgreement,
    Currency,
    requestLease,
    templateLease,
    party
  },
  data() {
    return {
      showValueSetModal: false,
      parent_value_set_id: null,
      showCustomerSiteModal: false,
      showMasterLeaseAgreementList: false,
      showTenantLeaseList: false,
      openCurrencyModal: false,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      totalRows: null,
      currentPage: 1,
      legalEntity: {
        value: null,
        text: null
      },
      operatingUnit: {
        value: null,
        text: null
      },
      sourceName: {
        value: null,
        text: null
      },
      request: {
        value: null,
        text: null
      },
      template: {
        value: null,
        text: null
      },
      sourceNameList: [],
      transType: {
        value: null,
        text: null
      },
      transTypeList: [],
      batchNumber: null,
      billNo: null,
      scheduleType: {
        value: null,
        text: null
      },
      recoveryType: {
        value: null,
        text: null
      },
      billingPeriodUom: {
        value: null,
        text: null
      },
      masterLeaseAgreement: {
        value: null,
        text: null
      },
      tenantLease: {
        value: null,
        text: null
      },
      billingUom: {
        value: null,
        text: null
      },
      dueDate: [],
      glDate: [],
      prjName: {
        value: null,
        text: null
      },
      towerName: {
        value: null,
        text: null
      },
      floorName: {
        value: null,
        text: null
      },
      unitName: {
        value: null,
        text: null
      },
      selectedCustomer: {
        name: null,
        id: null,
        siteName: null,
        siteId: null
      },
      currency: {
        name: null,
        id: null
      },
      customerId: null,
      customer_id: null,
      customer_name: null,
      customer_site_id: null,
      customer_site_name: null,
      gridDataSite: [],
      gridFieldsSite: [
        {
          key: 'site_name'
        },
        {
          key: 'site_type'
        },
        {
          key: 'bill_to_address',
          label: 'Site Address'
        },
        {
          key: 'ou_name',
          label: 'Operating Unit'
        },
        {
          key: 'gstn',
          label: 'GSTN'
        }
      ],
      startDate: null,
      endDate: null,
      start_date_end_date: [],
      amtFrom: null,
      amtTo: null,
      billingStatusList: [],
      selectedBillingStatus: {
        value: null,
        text: null
      },
      vsetCode: null,
      setTimeVsetCode: null,
      showCommonModal: false,
      modalType: null,
      depVsetParam: null,
      defaultValue: {
        value: null,
        text: null
      }
    };
  },
  mounted() {
    const advFormData = this.$store.state.leaseInvoice.advSearchFilters;
    if (advFormData) {
      this.setSearchItems(advFormData);
    } else {
      this.getSourceNameList();
      this.getBillingStatus();
      this.getTxnTypeList();
      this.eventBus.$on('getCurrency', getCurrency => {
        this.currency.name = getCurrency.currency;
        this.currency.id = getCurrency.currency_id;
        this.openCurrencyModal = false;
      });
    }
  },
  methods: {
    getSourceNameList() {
      const payload = {
        module_id: store.state.shared.moduleId
      };
      this.$store
        .dispatch('leases/getSourceNameList', payload)
        .then(response => {
          if (response.status === 200) {
            const results = response.data.data;
            const srcNameList = results.map(type => {
              return {
                value: type.source_hdr_id,
                text: type.source_name
              };
            });
            this.sourceNameList = srcNameList;
          }
        });
    },
    onSelectSourceType(event) {
      this.sourceName.text = event.text;
      this.sourceName.value = event.value;
    },
    getTxnTypeList() {
      const moduleId = store.state.shared.moduleId;
      this.$store.dispatch('leases/getTxnTypeList', moduleId).then(response => {
        if (response.status === 200) {
          const results = response.data.data;
          const typeList = results.map(type => {
            return {
              value: type.trx_type_dtl_id,
              text: type.trx_desc
            };
          });
          this.transTypeList = typeList;
        }
      });
    },
    getBillingStatus() {
      this.$store
        .dispatch('receipt/getLOVBySetType', 'BILL_STATUS')
        .then(response => {
          if (response.status === 200) {
            const results = response.data.data;
            const getValueAndText = results.map(type => {
              return {
                value: type.value_code,
                text: type.value_meaning
              };
            });
            this.billingStatusList = getValueAndText;
          }
        });
    },
    openCloseCurrency(flag) {
      this.$store.dispatch('party/setUnsetPartyId', 1);
      this.openCurrencyModal = flag;
    },
    selectedvalueSet(item) {
      if (this.vsetCode === appStrings.VALUESETTYPE.LEASE_SCHEDULE_TYPE) {
        this.scheduleType = {
          value: item.value_code,
          text: item.value_meaning
        };
        this.recoveryType = {
          value: null,
          text: null
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.LEASE_RECOVERY) {
        this.recoveryType = {
          value: item.value_code,
          text: item.value_meaning
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.UOM) {
        this.billingPeriodUom = {
          value: item.value_code,
          text: item.value_meaning
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.LEASE_PROJECT_LIST) {
        this.prjName = {
          value: item.value_set_dtl_id,
          text: item.value_code
        };
        this.towerName = {
          value: null,
          text: null
        };
        this.floorName = {
          value: null,
          text: null
        };
        this.unitName = {
          value: null,
          text: null
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.LEASE_TOWER_LIST) {
        this.towerName = {
          value: item.value_set_dtl_id,
          text: item.value_code
        };
        this.floorName = {
          value: null,
          text: null
        };
        this.unitName = {
          value: null,
          text: null
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.LEASE_FLOOR_LIST) {
        this.floorName = {
          value: item.value_set_dtl_id,
          text: item.value_code
        };
        this.unitName = {
          value: null,
          text: null
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.LEASE_UNIT_LIST) {
        this.unitName = {
          value: item.value_set_dtl_id,
          text: item.value_code
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.LEGAL_ENTITY_LIST) {
        this.legalEntity.text = item.value_code;
        this.legalEntity.value = item.value_set_dtl_id;
        this.operatingUnit.text = null;
        this.operatingUnit.value = null;
      } else if (this.vsetCode === appStrings.VALUESETTYPE.OU_LIST) {
        this.operatingUnit.text = item.value_code;
        this.operatingUnit.value = item.value_set_dtl_id;
      } else if (
        this.vsetCode === appStrings.VALUESETTYPE.SCHEDULE_STATUS_VSET
      ) {
        this.selectedBillingStatus.text = item.value_meaning;
        this.selectedBillingStatus.value = item.value_code;
      }
      this.showValueSetModal = false;
    },
    openValueSetModal(vsetCode, valuseSetDtlId) {
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      this.parent_value_set_id = null;
      this.depVsetParam = null;
      if (
        this.vsetCode === appStrings.VALUESETTYPE.OU_LIST ||
        this.vsetCode === appStrings.VALUESETTYPE.LEASE_PROJECT_LIST
      ) {
        this.parent_value_set_id = this.legalEntity.value;
        this.depVsetParam = this.operatingUnit.value;
      }
      if (this.vsetCode === appStrings.VALUESETTYPE.LEASE_TOWER_LIST) {
        this.parent_value_set_id = this.prjName.value;
      } else if (this.vsetCode === appStrings.VALUESETTYPE.LEASE_FLOOR_LIST) {
        this.parent_value_set_id = this.towerName.value;
      } else if (this.vsetCode === appStrings.VALUESETTYPE.LEASE_UNIT_LIST) {
        this.parent_value_set_id = this.floorName.value;
      } else if (this.vsetCode === appStrings.VALUESETTYPE.UOM) {
        this.parent_value_set_id = valuseSetDtlId;
      }
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    opendDependentUom(vsetCode) {
      const payload = {
        valueSetName: vsetCode,
        dependentVariable: {
          user_id: this.$store.state.auth.userId,
          res_id: this.$store.state.shared.responsibilityId
        }
      };
      this.loader = true;
      this.$store
        .dispatch('shared/getCommonVSetData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            const findTimeObj = response.data.data.page.find(
              vsetData => vsetData.value_code === 'TIME'
            );
            if (findTimeObj) {
              this.openValueSetModal(
                appStrings.VALUESETTYPE.UOM,
                findTimeObj.value_set_dtl_id
              );
            }
          }
        });
    },
    selectedLeaseTenant(item) {
      this.tenantLease = {
        value: item.lease_tenant_agreement_hdr_id,
        text: item.lease_tenant_agreement_no
      };
      this.showHideCommonLeaseModal(false, null);
    },
    selectedLeaseMaster(item) {
      this.masterLeaseAgreement = {
        value: item.lease_master_agreement_hdr_id,
        text: item.lease_agreement_no
      };
      this.showHideCommonLeaseModal(false, null);
    },
    selectedRequestNum(item) {
      this.request = {
        value: item.request_id,
        text: item.name
      };
      this.showHideCommonLeaseModal(false, null);
    },
    selectedtemplate(item) {
      this.template = {
        value: item.template_id,
        text: item.template_name
      };
      this.showHideCommonLeaseModal(false, null);
    },
    selectedUserName(item) {
      this.selectedCustomer.name = item.party_name;
      this.getCustomerByPartyId(item.party_id);
      this.showCommonModal = false;
    },
    getCustomerByPartyId(partyId) {
      this.$store
        .dispatch('leases/getCustomerByPartyId', partyId)
        .then(response => {
          if (response.status === 200) {
            this.selectedCustomer.id = response.data.data.customer_id;
            this.customer_id = response.data.data.customer_id;
            this.getCustomerSiteByPartyId();
          }
        });
    },
    getCustomerSiteByPartyId() {
      const payload = {
        customerId: this.customer_id,
        lease: {
          site_type_vset: appStrings.siteTypeVset
        }
      };
      this.$store
        .dispatch('party/getCustomerSiteById', payload)
        .then(response => {
          this.gridDataSite = response.data.data.customer_site_lists;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    searchAdvParams() {
      const payload = {
        le_name: this.legalEntity.text,
        ou_name: this.operatingUnit.text,
        searchParams: {
          le_id: this.legalEntity.value,
          ou_id: this.operatingUnit.value,
          source_hdr_id: this.sourceName.value,
          trx_type_dtl_id: this.transType.value,
          lease_master_agreement_hdr_id: this.masterLeaseAgreement.value,
          lease_tenant_agreement_hdr_id: this.tenantLease.value,
          batch_number: this.batchNumber,
          lease_schedule_type_vset: this.scheduleType.value,
          recovery_type_vset: this.recoveryType.value,
          bill_uom: this.billingPeriodUom.value,
          bill_no: this.billNo,
          due_date_from: commonHelper.formattedDate(this.dueDate[0]),
          due_date_to: commonHelper.formattedDate(this.dueDate[1]),
          gl_date_from: commonHelper.formattedDate(this.glDate[0]),
          gl_date_to: commonHelper.formattedDate(this.glDate[1]),
          customer_id: this.selectedCustomer.id,
          customer_site_id: this.selectedCustomer.siteId,
          transactional_currency_id: this.currency.id,
          billing_period_start_date: commonHelper.formattedDate(
            this.start_date_end_date[0]
          ),
          billing_period_end_date: commonHelper.formattedDate(
            this.start_date_end_date[1]
          ),
          total_amount_from: this.amtFrom,
          total_amount_to: this.amtTo,
          bill_status_vset: this.selectedBillingStatus.value,
          lease_prj_id: this.prjName.value,
          tower_id: this.towerName.value,
          floor_id: this.floorName.value,
          lease_prj_unit_id: this.unitName.value,
          request_id: this.request.value
        }
      };
      this.$emit('advanceSearch', payload);
      this.$store.dispatch('leaseInvoice/saveAdvSearchFilters', this);
      // this.$store.state.leaseInvoice.leaseInvoice.adv_search = this;
    },
    clearParams() {
      this.legalEntity = {
        value: null,
        text: null
      };
      this.operatingUnit = {
        value: null,
        text: null
      };
      this.masterLeaseAgreement = {
        value: null,
        text: null
      };
      this.tenantLease = {
        value: null,
        text: null
      };
      this.selectedBillingStatus = {
        value: null,
        text: null
      };
      this.sourceName = {
        value: null,
        text: null
      };
      this.sourceNameList = [];
      this.transType = {
        value: null,
        text: null
      };
      this.batchNumber = null;
      this.scheduleType = {
        value: null,
        text: null
      };
      this.recoveryType = {
        value: null,
        text: null
      };
      this.billingPeriodUom = {
        value: null,
        text: null
      };
      this.billNo = null;
      this.dueDate = [];
      this.glDate = [];
      this.selectedCustomer = {
        name: null,
        id: null,
        siteName: null,
        siteId: null
      };
      this.currency = {
        name: null,
        id: null
      };
      this.start_date_end_date = [];
      this.amtFrom = null;
      this.amtTo = null;
      this.prjName = {
        value: null,
        text: null
      };
      this.towerName = {
        value: null,
        text: null
      };
      this.floorName = {
        value: null,
        text: null
      };
      this.unitName = {
        value: null,
        text: null
      };
      this.request = {
        value: null,
        text: null
      };
      this.transTypeList = [];
      this.sourceNameList = [];
      this.billingStatusList = [];
      this.$store.dispatch('leaseInvoice/saveAdvSearchFilters', null);
      // this.$store.state.leaseInvoice.leaseInvoice.adv_search = null;
    },
    showHideCustomerSiteModal(flag) {
      if (this.selectedCustomer.name) {
        this.showCustomerSiteModal = flag;
      } else {
        alert('Please Select Customer First');
      }
    },
    selectedSite(item) {
      this.selectedCustomer.siteName = item.site_name;
      this.selectedCustomer.siteId = item.customer_site_id;
      this.showCustomerSiteModal = false;
    },
    showHideCommonLeaseModal(flag, modalType) {
      this.showCommonModal = flag;
      this.modalType = modalType;
      setTimeout(() => {
        this.eventBus.$emit('userType', 'CUST');
      }, 0);
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    setDate(dateRange) {
      this.start_date_end_date = commonHelper.setFutureDate(dateRange);
    },
    setSearchItems(item) {
      this.legalEntity = item.legalEntity;
      this.operatingUnit = item.operatingUnit;
      this.masterLeaseAgreement = item.masterLeaseAgreement;
      this.tenantLease = item.tenantLease;
      this.selectedBillingStatus = item.selectedBillingStatus;
      this.sourceName = item.sourceName;
      this.sourceNameList = item.sourceNameList;
      this.transType = item.transType;
      this.batchNumber = item.batchNumber;
      this.scheduleType = item.scheduleType;
      this.recoveryType = item.recoveryType;
      this.billingPeriodUom = item.billingPeriodUom;
      this.billNo = item.billNo;
      this.dueDate = item.dueDate;
      this.glDate = item.glDate;
      this.selectedCustomer = item.selectedCustomer;
      this.currency = item.currency;
      this.start_date_end_date = item.start_date_end_date;
      this.amtFrom = item.amtFrom;
      this.amtTo = item.amtTo;
      this.prjName = item.prjName;
      this.towerName = item.towerName;
      this.floorName = item.floorName;
      this.unitName = item.unitName;
      this.request = item.request;
      this.transTypeList = item.transTypeList;
      this.sourceNameList = item.sourceNameList;
      this.billingStatusList = item.billingStatusList;
    },
    clearVsetValues(vsetCode) {
      switch (vsetCode) {
        case this.legalEntity.value:
          this.legalEntity = this.defaultValue;
          break;
        case this.operatingUnit.value:
          this.operatingUnit = this.defaultValue;
          break;
        case this.scheduleType.value:
          this.scheduleType = this.defaultValue;
          break;
        case this.billingPeriodUom.value:
          this.billingPeriodUom = this.defaultValue;
          break;
        case this.selectedBillingStatus.value:
          this.selectedBillingStatus = this.defaultValue;
          break;
        case this.prjName.value:
          this.prjName = this.defaultValue;
          break;
        case this.towerName.value:
          this.towerName = this.defaultValue;
          break;
        case this.floorName.value:
          this.floorName = this.defaultValue;
          break;
        case this.unitName.value:
          this.unitName = this.defaultValue;
          break;
      }
    }
  },
  destroyed() {
    this.eventBus.$off('getCurrency');
  }
};
